import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import type { DS_TData } from '../DS/DS.Data'
import { IDB_homePage } from '../IDB/IDB.dexie'
import { Rout_toPlanner } from './Rout.planner'
import { Rout_toLocationSearch } from './Rout.location'
import { User_hasPriv } from '../User/User.get'
import { Rout_toSearch, Rout_replaceToSearch } from './Rout.search'
import { Rout_replaceToTodo, Rout_toTodo } from './Rout.todo'
import { Rout_toUserActions } from './Rout.action'

export async function Rout_toHome(replace: boolean, d?: DS_TData) {
    if (Cust_hasSingleLocation()) {
        const lastHomePage = await IDB_homePage().get()

        if (lastHomePage === 'search') {
            if (replace) {
                Rout_replaceToSearch()
            } else {
                Rout_toSearch()
            }
        } else if (lastHomePage === 'user-actions') {
            Rout_toUserActions()
        } else {
            if (replace) {
                Rout_replaceToTodo()
            } else {
                Rout_toTodo()
            }
        }
    } else if (User_hasPriv('planner', d)) {
        Rout_toPlanner()
    } else {
        Rout_toLocationSearch()
    }
}
